/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './pharmacy-supplier-attribute.reducer';

export const PharmacySupplierAttributeDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const pharmacySupplierAttributeEntity = useAppSelector(state => state.pharmacySupplierAttribute.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="pharmacySupplierAttributeDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.pharmacySupplierAttribute.detail.title">PharmacySupplierAttribute</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.pharmacySupplierAttribute.id">Id</Translate>
            </span>
          </dt>
          <dd>{pharmacySupplierAttributeEntity.id}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.pharmacySupplierAttribute.active">Active</Translate>
            </span>
          </dt>
          <dd>{pharmacySupplierAttributeEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.pharmacySupplierAttribute.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{pharmacySupplierAttributeEntity.lastUpdated}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.pharmacySupplierAttribute.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{pharmacySupplierAttributeEntity.timestampEntry}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.pharmacySupplierAttribute.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{pharmacySupplierAttributeEntity.microSec}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.pharmacySupplierAttribute.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{pharmacySupplierAttributeEntity.cursor}</dd>
          <dt>
            <span id="key">
              <Translate contentKey="tinyMedicRestApp.pharmacySupplierAttribute.key">Key</Translate>
            </span>
          </dt>
          <dd>{pharmacySupplierAttributeEntity.key}</dd>
          <dt>
            <span id="value">
              <Translate contentKey="tinyMedicRestApp.pharmacySupplierAttribute.value">Value</Translate>
            </span>
          </dt>
          <dd>{pharmacySupplierAttributeEntity.value}</dd>
          <dt>
            <span id="comments">
              <Translate contentKey="tinyMedicRestApp.pharmacySupplierAttribute.comments">Comments</Translate>
            </span>
          </dt>
          <dd>{pharmacySupplierAttributeEntity.comments}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pharmacySupplierAttribute.pharmacySuppliers">Pharmacy Suppliers</Translate>
          </dt>
          <dd>{pharmacySupplierAttributeEntity.pharmacySuppliers ? pharmacySupplierAttributeEntity.pharmacySuppliers.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pharmacySupplierAttribute.pharmacy">Pharmacy</Translate>
          </dt>
          <dd>{pharmacySupplierAttributeEntity.pharmacy ? pharmacySupplierAttributeEntity.pharmacy.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/pharmacy-supplier-attribute" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/pharmacy-supplier-attribute/${pharmacySupplierAttributeEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default PharmacySupplierAttributeDetail;
